const users = {
  module: "Brukere",
  title: "Brukere",
  new_user: "Ny bruker",
  edit_user: "Rediger bruker: {name}",
  edit_account: "Rediger: {name}",
  edit_role: "Rediger rolle: {name}",
  view_user: "Vis bruker: {name}",
  person_title: "Bruker detaljer",
  list_title: "Brukere",
  list_subtitle: "Håndtere brukere",
  details_title: "Brukerdetaljer",
  account_title: "Kontodetaljer",
  address_title: "Addresse",
  organisation_title: "Organisasjons detaljer",
  account_setting: "Rediger profil",
  view_details: "Vis detaljer",
  id: "ID",
  pid: "Personnummer",
  identification: "Personnummer",
  unique_id: "ID",
  first_name: "Fornavn",
  last_name: "Etternavn",
  middle_name: "Mellomnavn",
  mobile: "Mobil",
  status: "Status",
  logs: "Logger",
  email: "Epost",
  password: "Passord",
  company_name: "Selskapsnavn",
  company_vat: "Orgnr",
  search_organisations: "Søk for organisasjoner...",
  merge_students: "Slå sammen elever",
  merge_success: "Elever er blitt slått sammen.",
  merge_failed: "Sammenslåing feilet.",
  profile: "Profil",
  changepass: "Endre passord",
  sync_ok: "Synkronisert",
  verify: "Bekreft",
  image_not_verified: "Bilde ikke bekreftet",
  verify_image_confirmation: "Vil du bekrefte bilde?",
  verify_success: "Bilde bekreftet.",
  documents: "Dokumenter",
  add_documents: "Legg til",
  documents_notice:
    "Dokumenter lastet opp her vil være synlige for kursvirksomheter. Ønsker du å få digitalisert tidligere  kompetanse/bevis last opp dokumenter her og ta kontakt med opplæringsvirksomheten din for autorisasjon.",
  upload_documents: "Last opp",
  enter_code: "Tast inn kode",
  enter_code_email: "Bekreftelseskode er sendt til {email}",
  email_verification_send_failed:
    "Epost er ikke sendt. Vennligst kontakt NOORSI.",
  email_verification_incorrect_code: "Feil kode.",
  enter_code_sms: "Bekreftelseskode er sendt til {mobile}",
  sms_otp_send_failed: "SMS er ikke sendt. Vennligst kontakt NOORSI.",
  sms_otp_incorrect_code: "Feil kode.",
  access_granted: "Tilgang gitt",
  companies_employed: "Ansatt hos",
  company_vat_not_exist:
    "Selskap med dette org.nr. er ikke registrert i Kompetanse web.",
  company_already_has_access:
    "Dette selskapet har allerede tilgang til denne brukeren",
  new_company_access: "Legg til tilgang for selskap",
  edit_company_access: "Rediger tilgang",
  cancel_enrolment: "Kanseller påmelding",
  cancel_enrolment_confirmation: "Er du sikker at du vil kansellere påmelding?",
  cancel_enrolment_success: "Påmelding kansellert.",
  cancel_enrolment_failed: "Kansellering av påmelding feilet.",
  qr_show: "Vis QR",
  qr_control: "Kontroll",
  qr_scan_title: "Skann QR kode",
  qr_rescan: "Skann igjen QR kode",
  qr_waiting_user_confirm: "Vennter på godkjenning ...",
  qr_confirmation_view_data:
    "Vil du gi {name} midlertidig tilgang til din kompetanse?",
  qr_user_denied: "Bruker tilgang avvist.",
  qr_use_access_expired: "Adgang utløpt",
  age_below_18:
    "Personer under 18 år kan ikke utføre arbeid som medfører fare for liv eller helse. Forskrift om administrative ordninger §12-6 Selv om personen har fått og bestått opplæring som beskrevet under, kan ikke personer under 18 år, settes til selvstendig arbeid som kan medføre fare for live eller helse. Denne type arbeid kan bare gjennomføres som del av yrkesrettet opplærings, iht. unntak fra arbeidsforbud, Forskrift om organisering og ledelse §12-7",
  show_deleted_documents: "Papirkurv",
  show_documents: "Tilbake",
  deleted_documents: "(I papirkurv)",
  find_duplicates: "Finn duplikater",
  merge_and_next: "Slå sammen og neste",
  skip_and_next: "Hopp over",
  duplicate_of: "Duplikat {counter} av {count}",
  found_potentials: "Funnet {count} mulige duplikater",
  equal_identification_number: "Samme pnr",
  equal_mobile_number: "Samme mobilnr",
  equal_email: "Samme epost",
  equal_first_name: "Samme fornavn",
  equal_last_name: "Samme etternavn",
  equal_birthday: "Samme fødselsdato",
  no_duplicate_found: "Duplikat ikke funnet",
  tenant: "Klient administrasjon",
  subdomain: "Subdomene",
  deparment: "Avdeling",
  employee_number: "Ansattnummer",
  edit: {
    password_no_match: "Passordd er ikke likt",
    personal_info: "Personlig informasjon",
    old_pass: "Nåværende passord",
    new_pass: "Nytt passord",
    confirm_pass: "Bekreft passord",
    password_success: "Passord endret.",
    password_error: "Endring av passord feilet. Nåværende passord er feil!",
  },
}
export default users
